import FortesFiscalService from "../../../services/resource/fortesFiscalService";

import { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { Loading } from "../../../componentes/loading/loading";
import DropDown from "../../../componentes/dropdown/dropdown";
import InputForm from "../../../componentes/input/input";
import { toast } from 'react-toastify';
import SelectForm from "../../../componentes/select/select";
import ApiDocEmpregados from "./APIDocEmpregado";
import { returnDate } from "../../../utils/formatDate";
import MotoristaService from "../../../services/resource/motoristaService";
import { reduzirNome } from "../../../utils/reduzirNome";
import Button from "../../../componentes/button/button";

export default function ListaEmpregados() {
  const [dados, setDados] = useState([]);
  const [motoristas, setMotoristas] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [loadingExportacao, setLoadingExportacao] = useState(false);
  const [selectedMotorista, setSelectedMotorista] = useState({});
  const [isOpen, setIsOpen] = useState(false);
  const [empresas, setEmpresas] = useState([]);
  const [codigoEmpresa, setCodigoEmpresa] = useState("0184");
  const [nome, setNome] = useState("");
  const [cargosSelecionados, setCargosSelecionados] = useState(["MOTORISTA", "MOTORISTA I", "MOTORISTA II", "MOTORISTA III"]);

  const [dtRescisaoNull, setDtRescisaoNull] = useState(true);

  const service = new FortesFiscalService();
  const motoristaService = new MotoristaService();
  const FileDownload = require("js-file-download");
  const navigate = useNavigate();

  useEffect(() => {
    listarEmpresas();
    listarEmpregados();
    listarMotorista();
    document.title = "MyDash | Listagem Funcionários"
  }, []);

  const handleCargoChange = (e) => {
    const selected = Array.from(e.target.selectedOptions, option => option.value);
    setCargosSelecionados(selected);
  };

  const listarEmpresas = () => {
    service
      .buscarEmpresas()
      .then((res) => setEmpresas(res.data))
      .catch((err) => console.error(err));
  };

  const listarEmpregados = () => {
    setLoading(true);
    service
      .buscarEmpregadoCargo({
        empCodigo: codigoEmpresa,
        nome: nome,
        cargos: cargosSelecionados,
        ativos: dtRescisaoNull
      })
      .then((res) => {
        setDados(res.data);
        if (res.data.length <= 0) toast.warning("Nenhum registro encontrado!");
      })
      .catch((err) => console.error(err.response?.data?.message || err.message))
      .finally(() => setLoading(false));
  };
  
  const listarMotorista = () => {
    motoristaService.findAll()
      .then((res) => {
        setMotoristas(res.data.content);
      })
      .catch((err) => console.error(err.response?.data?.message || err.message))
      .finally(() => setLoading(false));
  };

  const exportarEmpregados = () => {
    setLoadingExportacao(true);
    service
      .exportListaEmpregados({
        empCodigo: codigoEmpresa,
        nome: nome,
        cargos: cargosSelecionados,
        ativos: dtRescisaoNull
      })
      .then((res) => {
        const date = new Date();
        FileDownload(res.data, "Empregados_" + date.getTime() + ".xlsx");
        setLoadingExportacao(false);
      })
      .catch((err) => {
        setLoadingExportacao(false)
        console.error(err.message)
      })
  };

  const filteredMotoristas = motoristas.filter((item) => {
    // percorre todos os valores do objeto e verifica se algum contém o termo
    return Object.values(item).some((value) => {
      if (!value) return false; // ignora valores nulos/undefined
      return value.toString().toLowerCase().includes(search.toLowerCase());
    });
  });

  const handleChange = (e) => {
    setSelectedMotorista({
      ...selectedMotorista,
      [e.target.name]: e.target.value,
    });
  };

  const openModal = (motorista) => {
    setSelectedMotorista(motorista);
    setIsOpen(true);
  };

  const closeModal = () => {
    setSelectedMotorista(null);
    setIsOpen(false);
  };

  const handleSave = () => {
    motoristaService.update({
      id: selectedMotorista.id,
      name: selectedMotorista.name,
      cpf: selectedMotorista.cpf,
      code: selectedMotorista.code,
      cargo: selectedMotorista.cargo,
      dataAdmissao: selectedMotorista.dataAdmissao,
    }).then(() => {
      listarMotorista();
    }).catch((e) => console.error(e))

    closeModal();
  };

  const ajustarMotoristas = () => {
    motoristaService.ajustarMotorista().then(response => {
      listarMotorista();
      toast.success("Dados alterados!");
    }).catch(error => {
      console.error(error)
    })
  }

  return (
    <>
      <div id="report-detail" className="w-full px-6 pt-6">
        <div className="flex justify-between mb-6">
          <button onClick={() => navigate(-1)} className="text-primary hover:opacity-80 transition-colors duration-150">
            <i className="fas fa-arrow-left mr-2"></i> Voltar
          </button>
          <div className="flex space-x-3">
            <Button
              onClick={exportarEmpregados}
              variant="white"
              label="Exportar"
              iconLeft="fas fa-download"
              loading={loadingExportacao}
            />
            <Button
              onClick={listarEmpregados}
              variant="indigo"
              label="Atualizar"
              iconLeft="fas fa-sync-alt"
              loading={loading}
            />
          </div>
        </div>

        <div className="bg-card border border-border rounded-xl shadow-soft overflow-hidden mb-6">
          <div className="p-6 border-b border-border flex items-center">
            <div className="bg-primary/10 p-3 rounded-lg mr-4">
              <i className="fas fa-users text-primary text-xl"></i>
            </div>
            <div>
              <h2 className="text-xl font-display font-bold text-foreground">Empregados e Cargos</h2>
              <p className="text-muted-foreground">Relatório detalhado</p>
            </div>
          </div>

          <div className="p-6 flex flex-wrap gap-3">
            <div className="w-full md:w-3/4 flex flex-col sm:flex-row gap-3">
              <div className="w-full">
                <DropDown
                  label="Empresa"
                  className="w-full"
                  options={empresas}
                  optionLabel="CODIGO"
                  optionLabel2="NOME"
                  optionValue="CODIGO"
                  value={codigoEmpresa}
                  placeholder="Todas"
                  onChange={(e) => setCodigoEmpresa(e)}
                />
              </div>
              <div className="w-full">
                <InputForm className="w-full" label="Nome" value={nome} onChange={(e) => setNome(e.target.value)} />

              </div>
              <div className="w-full">
                <label className="flex items-center space-x-2 mt-4 pt-2">
                  <input type="checkbox" checked={dtRescisaoNull} onChange={(e) => setDtRescisaoNull(e.target.checked)} />
                  <span>Somente ativos</span>
                </label>
              </div>
            </div>
            <div className="w-full md:w-3/3 flex flex-col sm:flex-row gap-3">
              <div className="flex-1">

                <SelectForm
                  label="Cargos"
                  name="cargos"
                  options={["MOTORISTA", "MOTORISTA I", "MOTORISTA II", "MOTORISTA III", "CARRETEIRO", "AUXILIAR DE ENTREGA", "AUXILIAR DE CARGA E DESCARGA"]}
                  value={cargosSelecionados}
                  onChange={handleCargoChange}
                  multiple={true}
                />
              </div>
            </div>



            {loading ? (
              <Loading label="Carregando Dados" />
            ) : (
              <div className="table-responsive overflow-y-auto" style={{ maxHeight: '70vh' }} >
                <table className="table  text-sm text-left rtl:text-right text-muted-foreground">
                  <thead className="bg-table-header text-table-header-fg sticky top-0">
                    <tr>
                      <th className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider">Empresa</th>
                      <th className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider">Código</th>
                      <th className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider">Nome</th>
                      <th className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider">Cargo</th>
                      <th className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider">Admissão</th>
                      <th className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider">Rescisão</th>
                    </tr>
                  </thead>
                  <tbody>
                    {dados.map((item, idx) => (
                      <tr key={idx} className="table-items hover:bg-table-row-hover transition-colors">
                        <td>{item.empresa}</td>
                        <td>{item.codigo}</td>
                        <td>{item.nome}</td>
                        <td>{item.cargo}</td>
                        <td>{returnDate(item.admissaoData)}</td>
                        <td>{returnDate(item.dtRescisao) || "-"}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </div>
      <div id="report-detail" className="w-full px-6">
        <div className="bg-card border border-border rounded-xl shadow-soft overflow-hidden mb-6">
          <div className="p-6 border-b border-border flex items-center">
            <div className="bg-primary/10 p-3 rounded-lg mr-4">
              <i className="fas fa-users text-primary text-xl"></i>
            </div>
            <div>
              <h2 className="text-xl font-display font-bold text-foreground">Motoristas Trixlog</h2>
              <p className="text-muted-foreground">Relatório detalhado</p>
            </div>
          </div>

          <div className="p-6 flex flex-wrap gap-3">
            <div className="w-full flex flex-col sm:flex-row gap-3">
              <div className="w-full">
                <InputForm
                  type="text"
                  placeholder="Buscar em qualquer campo"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  className="form-control mb-3"
                />
                <div className="table-responsive overflow-y-auto" style={{ maxHeight: '70vh' }} >
                  <table className="table  text-sm text-left rtl:text-right text-muted-foreground">
                    <thead className="bg-table-header text-table-header-fg sticky top-0 text-sm">
                      <tr>
                        <th className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider">ID</th>
                        <th className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider">AC</th>
                        <th className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider">Filial</th>
                        <th className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider">Nome</th>
                        <th className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider">Cargo</th>
                        <th className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider">CPF</th>
                        <th className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider">Admissão</th>
                        <th className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider">Rescisão</th>
                        <th className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider">Ativo</th>
                        <th className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider">Ações</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredMotoristas.map((item, idx) => (
                        <tr key={idx} className="table-items text-sm hover:bg-table-row-hover transition-colors">
                          <td>{item.id}</td>
                          <td className="text-center">{item.code}</td>
                          <td>{item.branchName}</td>
                          <td>{reduzirNome(item.name)}</td>
                          <td>{item.cargo}</td>
                          <td>{item.cpf}</td>
                          <td>{returnDate(item.dataAdmissao)}</td>
                          <td>{returnDate(item.dataDemissao) || "-"}</td>
                          <td>{item.ativo ? "ATIVO" : 'INATIVO'}</td>
                          <td><button onClick={() => openModal(item)} className="btn btn-primary btn-sm" >Editar</button></td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <hr />
            <button className="btn btn-secondary btn-sm mt-3" onClick={ajustarMotoristas}><strong>Ajustar Dados Pelo Fortes </strong></button>
          </div>

        </div>
      </div>

      <div className="w-full px-6 pb-6">
        <ApiDocEmpregados />
      </div>

      {isOpen && selectedMotorista && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-card border border-border rounded-lg shadow-pop w-96 p-6">
            <h2 className="text-xl font-display font-semibold mb-4 text-foreground">Editar Motorista</h2>

            <div className="space-y-3">
              <InputForm
                label="Nome"
                type="text"
                name="name"
                value={selectedMotorista.name}
                onChange={handleChange}
                className="w-full border border-input p-2 rounded-lg focus:ring-2 focus:ring-primary/40 focus:border-primary transition-colors duration-150"
                placeholder="Nome"
              />
              <InputForm
                type="text"
                label="CPF"
                name="cpf"
                value={selectedMotorista.cpf}
                onChange={handleChange}
                className="w-full border border-input p-2 rounded-lg focus:ring-2 focus:ring-primary/40 focus:border-primary transition-colors duration-150"
                placeholder="CPF"
              />
              <InputForm
                type="text"
                label="Cargo"
                name="cargo"
                value={selectedMotorista.cargo}
                onChange={handleChange}
                className="w-full border border-input p-2 rounded-lg focus:ring-2 focus:ring-primary/40 focus:border-primary transition-colors duration-150"
                placeholder="Cargo"
              />
              <InputForm
                type="text"
                label="Código Funcionário (Fortes)"
                name="code"
                value={selectedMotorista.code}
                onChange={handleChange}
                className="w-full border border-input p-2 rounded-lg focus:ring-2 focus:ring-primary/40 focus:border-primary transition-colors duration-150"
                placeholder="Codigo do Fortes"
              />
              <InputForm
                type="datetime-local"
                label="Data Admissão"
                name="dataAdmissao"
                value={selectedMotorista.dataAdmissao}
                onChange={handleChange}
                className="w-full border border-input p-2 rounded-lg focus:ring-2 focus:ring-primary/40 focus:border-primary transition-colors duration-150"
                placeholder="Codigo do Fortes"
              />

            </div>


            <div className="flex justify-end space-x-2 mt-5">
              <button
                onClick={closeModal}
                className="px-4 py-2 rounded-lg bg-muted hover:bg-muted/70 text-foreground transition-colors duration-150"
              >
                Cancelar
              </button>
              <button
                onClick={handleSave}
                className="px-4 py-2 rounded-lg bg-primary text-primary-foreground hover:brightness-95 transition-colors duration-150"
              >
                Atualizar
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
